import React, { useMemo } from 'react';
import { Custom_Icons } from '../shared/constants/custom-icons';
import { CustomIcon } from './CustomIcon';
import { Button } from 'react-native-paper';
import { Props } from 'react-native-paper/lib/typescript/components/Button/Button';
import { useThemeSettings } from '../ThemeProvider';
import getGlobalStyles from '../globalStyles';

export enum ButtonVariant {
  NORMAL, // border -20 
  NORMAL_PRIMARY,
  RECTANGULAR, // border -12 
  TRANSPARENT
}
interface CustomIconButtonProps extends Props {
  icon?: string | any;
  iconSize?: number;
  variant?: ButtonVariant; // NORMAL;
}

export const CustomButton = ({ icon, children, iconSize, contentStyle, variant = ButtonVariant.NORMAL, mode = "contained", ...rest }: CustomIconButtonProps) => {
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);

  const getStyles = () => {
    let css: any = [];
    switch (variant) {
      case ButtonVariant.NORMAL:
        css = [gStyles.buttonStyle, rest.style, gStyles.shadow];
        break;
      case ButtonVariant.NORMAL_PRIMARY:
        css = [gStyles.buttonStyle, gStyles.buttonActiveStyle, rest.style];
        break;
      case ButtonVariant.RECTANGULAR:
        css = [gStyles.buttonStyle, gStyles.rectangularButton, rest.style];
      case ButtonVariant.TRANSPARENT:
        css = [gStyles.buttonStyle, gStyles.transparent, rest.style];
    }
    return css;
  }
  const getLabelStyles = () => {
    let css: any = [];
    switch (variant) {
      case ButtonVariant.NORMAL:
      case ButtonVariant.RECTANGULAR:
        css = [gStyles.buttonLabelStyle, rest?.labelStyle];
        break;
      case ButtonVariant.NORMAL_PRIMARY:
        css = [gStyles.buttonActiveLabelStyle, rest?.labelStyle];
        break
      case ButtonVariant.TRANSPARENT:
        css = [{ color: rest?.labelStyle?.color || theme?.colors?.primary }, rest?.labelStyle];
        break;
    }
    return css;
  }
  if (typeof icon !== 'string' || !Custom_Icons[icon as keyof typeof Custom_Icons]) {
    return typeof icon === 'string' && icon?.startsWith('https') ? <Button
      {...rest}
      mode={mode}
      labelStyle={getLabelStyles()}
      contentStyle={contentStyle}
      style={getStyles()}
      icon={() => (
        <CustomIcon icon={icon} size={iconSize ?? 16} color={getLabelStyles()[0].color}
        />
      )}
    >{children}</Button>
      :
      <Button
        {...rest}
        mode={mode}
        labelStyle={getLabelStyles()}
        contentStyle={contentStyle}
        style={getStyles()}
        icon={icon}
      >{children}</Button>;
  }
  return <Button
    {...rest}
    mode={mode}
    labelStyle={getLabelStyles()}
    contentStyle={contentStyle ? contentStyle : { height: 64 }}
    style={getStyles()}
    icon={() => (
      <CustomIcon icon={icon as keyof typeof Custom_Icons} size={iconSize ?? 16} color={getLabelStyles()[0].color} />
    )}
  >{children}</Button>;
};